"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _Form = require("../Form");

var DateField = function DateField(props) {
  var className = props.className,
      popOverClassName = props.popOverClassName,
      view = props.view,
      label = props.label,
      onChange = props.onChange,
      multiple = props.multiple,
      interval = props.interval,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "popOverClassName", "view", "label", "onChange", "multiple", "interval", "onBlur", "onFocus"]);
  var popOver = (0, _react.useRef)();
  var setDayPickerVisibility = (0, _react.useCallback)(function (visibility) {
    popOver.current.setVisible(visibility);
  }, [popOver]);
  var handleBlur = (0, _react.useCallback)(function (event) {
    event.persist();
    setTimeout(function () {
      if (popOver.current.element && !popOver.current.element.contains(document.activeElement)) {
        setDayPickerVisibility(false);
        onBlur(event);
      }
    }, 0);
  }, [onBlur, setDayPickerVisibility]);
  var handleFocus = (0, _react.useCallback)(function (event) {
    setDayPickerVisibility(true);

    if (onFocus) {
      onFocus(event);
    }
  }, [onFocus, setDayPickerVisibility]);
  var handleChange = (0, _react.useCallback)(function (value) {
    var valueCompleted = value && (!interval || value.from && value.to);
    var closeOnSelectionCompleted = !multiple;

    if (closeOnSelectionCompleted && valueCompleted) {
      setDayPickerVisibility(false);
    }

    onChange(value);
  }, [interval, multiple, onChange, setDayPickerVisibility]);
  return /*#__PURE__*/_react.default.createElement(_.PopOver, {
    placement: "bottom-start",
    className: popOverClassName,
    ref: popOver,
    content: /*#__PURE__*/_react.default.createElement(_.DayPicker, (0, _extends2.default)({
      variant: "fill",
      multiple: multiple,
      interval: interval,
      onChange: handleChange
    }, moreProps))
  }, /*#__PURE__*/_react.default.createElement(_.FieldWrapper, (0, _extends2.default)({
    fieldType: "Text",
    className: ("DateField " + className).trim(),
    Field: _.DateInput,
    label: label,
    interval: interval,
    multiple: multiple,
    onChange: handleChange,
    onClick: function onClick(event) {
      event.stopPropagation();
      event.preventDefault();
      setDayPickerVisibility(true);
      return event;
    },
    onFocus: handleFocus,
    onBlur: handleBlur
  }, moreProps)));
};

DateField.propTypes = {
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** A character/s to concatenate modifier classNames. It will be used to generate the component modifier className. */
  modifierChar: _propTypes.default.string,

  /** It extends component styles. */
  className: _propTypes.default.string,

  /** It extends PopOver component styles. */
  popOverClassName: _propTypes.default.string,

  /**
   * It specifies the design variant. It will be used as a modifier to generate the component className.
   - __fill__ DayPicker are high-emphasis.
   - __outline__ DayPicker are medium-emphasis.
   - __clear__ DayPicker are typically used for less-pronounced pickers. */
  variant: _propTypes.default.string,

  /** Field label */
  label: _propTypes.default.node,

  /** Selected day or days. It can be one of the following types:
   - __String__ Formated date string, ie: 'YYYY-MM-DD'. Require set format prop.
   - __Date__ An instance of Date.
   - __Array__ An array of formatted date strings or instances of Date. Require set __multiple__ prop to true.
   - __Object__ An object with from to props as formatted date string or instances of Date. Require set __interval__ prop to true. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _propTypes.default.shape({
    from: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),
    to: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string])
  }), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]))]),

  /** Callback function fired when day picker value change */
  onChange: _propTypes.default.func,

  /** Callback function fired when input is focused */
  onFocus: _propTypes.default.func,

  /** Callback function fired when input is blured */
  onBlur: _propTypes.default.func,

  /** Calendar mode of view. Can be visualized as a tooltip or always visible */
  view: _propTypes.default.oneOf(['visible', 'tooltip']),

  /** If true, DayPicker allow pick multiple dates. */
  multiple: _propTypes.default.bool,

  /** If true, DayPicker allow pick an interval of dates. */
  interval: _propTypes.default.bool
};
DateField.defaultProps = {
  className: '',
  view: 'visible',
  variant: 'outline'
};
DateField.displayName = 'DateField';

var _default = (0, _Form.formalizer)(DateField);

exports.default = _default;